import React from "react";
import { Check, ArrowUpRight } from "lucide-react";
import { wineryTiers } from "@/data/platforms";

const WineryListingTiers = ({ compact = false }) => {
  return (
    <section
      id="winery-tiers"
      className="px-5 sm:px-8 py-20"
      data-testid="winery-listing-tiers-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 max-w-3xl">
          <div className="eyebrow mb-4">
            Featured on vines.app, Virginia's wine directory + app
          </div>
          <h2 className="font-display text-4xl sm:text-5xl mb-4 leading-tight">
            Get discovered on the{" "}
            <span className="text-[var(--af-lime)]">platform we built</span> for
            Virginia wine.
          </h2>
          <p className="text-base sm:text-lg text-[var(--af-cream)]/75 max-w-2xl leading-relaxed">
            We own and operate{" "}
            <a
              href="https://vines.app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--af-lime)] underline-offset-4 hover:underline"
            >
              vines.app
            </a>{" "}
           , a directory of 280+ Virginia wineries with an interactive map and
            mobile app. Free for every winery. Upgrade to be the one visitors
            see first.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-7">
          {wineryTiers.map((t) => (
            <div
              key={t.key}
              className={`surface p-7 flex flex-col ${
                t.highlight
                  ? "border-[var(--af-lime)]/50 ring-1 ring-[var(--af-lime)]/30"
                  : ""
              }`}
              data-testid={`winery-tier-${t.key}`}
            >
              <div className="font-eyebrow text-xs uppercase tracking-widest text-[var(--af-lime)] mb-4">
                {t.name}
              </div>
              <div className="flex items-baseline gap-1 mb-2">
                <div className="font-display text-5xl lg:text-6xl">
                  {t.price}
                </div>
                <div className="text-sm text-[var(--af-cream)]/55">
                  {t.cadence !== "always" ? t.cadence : ""}
                </div>
              </div>
              <div className="text-sm mb-6 text-[var(--af-cream)]/70">
                {t.tagline}
              </div>
              <ul className="space-y-2.5 mb-6 flex-1">
                {t.bullets.map((b, i) => (
                  <li key={i} className="flex gap-2.5 text-sm">
                    <Check
                      size={16}
                      className="mt-0.5 flex-shrink-0 text-[var(--af-lime)]"
                    />
                    <span className="text-[var(--af-cream)]/90">{b}</span>
                  </li>
                ))}
              </ul>
              {t.key === "free" ? (
                <a
                  href="https://vines.app/for-wineries"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ghost-lime justify-center"
                  data-testid={`winery-tier-cta-${t.key}`}
                >
                  See your listing <ArrowUpRight size={14} />
                </a>
              ) : (
                <button
                  type="button"
                  disabled
                  aria-disabled="true"
                  className={`${t.highlight ? "btn-lime" : "btn-ghost-lime"} justify-center opacity-60 cursor-not-allowed pointer-events-none`}
                  data-testid={`winery-tier-cta-${t.key}`}
                >
                  Coming Soon
                </button>
              )}
            </div>
          ))}
        </div>

        {!compact && (
          <p className="text-xs text-[var(--af-cream)]/55 mt-8 font-eyebrow">
            * All paid tiers are month-to-month. No setup fees. Cancel anytime.
          </p>
        )}
      </div>
    </section>
  );
};

export default WineryListingTiers;
